<template>
  <!-- Page Content -->
  <div class="whole-page-long" id="whole-page-div">
    <div class="navbar-div">
      <Navbar
        :colorTheme="colorTheme"
        :selectedNavLink="null"
        :user="user"
        analysis="DOCS"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>
    <div style="z-index: 100000000!important;">
      <MegaMenu :model="items"></MegaMenu>
    </div>
    <div style="height: calc(100vh - 99px); overflow-y: auto;">
      <StaffMain v-if="selection === 'docs'" />
      <PRDs v-if="selection === 'prds'" :processData="processData" />
      <SDD v-if="selection === 'sdds'" :colorTheme="colorTheme" />
      <UserStories
        v-if="selection === 'userStories'"
        :processData="processData"
      />
    </div>
  </div>
</template>

<script>
import MegaMenu from "primevue/megamenu";
import Navbar from "@/components/Navbar.vue";
import PRDs from "@/components/documentation/PRDs";
import SDD from "@/components/documentation/SDD";
import StaffMain from "@/components/documentation/StaffMain";
import UserStories from "@/components/documentation/UserStories";
import { colorThemeChange, colorThemeVuex } from "@/_core/_helpers/_helpers";
import { getDocumentationItems } from "@/_core/data/Documentation";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { ProcessData } from "@/_core/data/ProcessData";

export default {
  name: "StaffDocumentation",
  components: {
    MegaMenu,
    Navbar,
    PRDs,
    SDD,
    StaffMain,
    UserStories
  },
  data() {
    return {
      colorTheme: true,
      selection: "userStories",
      items: [],
      processData: null,
      user: {}
    };
  },
  created() {
    this.processData = new ProcessData();
    this.overview_preferences = this.$store.state.user_preferences.all.items.overview_choices;
    try {
      this.colorTheme = this.overview_preferences.color_theme;
      if (this.colorTheme === undefined) {
        this.colorTheme = true;
      }
      if (!this.colorTheme) {
        colorThemeChange(this.root, this.colorTheme);
        this.onUserColorTheme(this.colorTheme);
      }
    } catch (error) {
      console.log(`Error color theme ${error}`);
    }
    this.overview_preferences = this.$store.state.user_preferences.all.items.overview_choices;
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    this.items = getDocumentationItems(this);
  },
  methods: {
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.overview_preferences.color_theme = val;
      colorThemeVuex(this, this.colorTheme);
      saveUserPreferences(this);
    },
    handleClick(val) {
      console.log("handleClick");
      console.log(val);
      this.selection = val;
    }
  }
};
</script>

<style scoped></style>
